import React, { useState, useEffect } from 'react';
import styled from '@emotion/styled';
import Star from '../../static/icons/star-bold.svg';
import StarActive from '../../static/icons/star-active.svg';
import { colors } from '../styles/colors';
import { devices } from '../styles/breakpoints';
import {
  isAlreadyinStorage,
  localStorageChecker,
  getLocalStorage,
  setLocalStorage,
} from '../utils';

const Button = styled.button`
  display: flex;
  flex-direction: column;
  background: transparent;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  transition: all 200ms ease-in-out;

  span {
    margin-top: 8px;
    font-size: 0.625em;
    line-height: 0.688em;
  }

  @media ${devices.nonTouchable} {
    &:hover {
      box-shadow: 0 0 0 15px ${colors['blue-rgba-one']};
      background: ${colors['blue-rgba-one']};
    }
  }

  &:focus-visible {
    box-shadow: 0 0 0 15px ${colors['blue-rgba-one']};
    background: ${colors['blue-rgba-one']};
  }

  &:active {
    box-shadow: 0 0 0 15px ${colors['blue-rgba-three']};
    background: ${colors['blue-rgba-three']};
  }

  &:focus {
    outline: 0;
  }
`;

const BookmarkButton = ({ title, slug }) => {
  const [isBookmarked, setIsBookmarked] = useState(false);

  const localStorageName = 'Merkliste';

  useEffect(() => {
    setIsBookmarked(isAlreadyinStorage(slug, localStorageName));
  }, [slug]);

  const handleClick = () => {
    if (localStorageChecker(localStorageName)) {
      localStorage.setItem(localStorageName, '[]');
    }

    const array = getLocalStorage(localStorageName);

    if (isBookmarked) {
      // remove from localStorage
      const newArray = array.filter((item) => item.slug !== `/${slug}`);

      setLocalStorage(newArray, localStorageName);
      setIsBookmarked(false);
    } else {
      // add to localStorage

      array.push({ slug: `/${slug}`, title: title });
      setIsBookmarked(true);

      setLocalStorage(array, localStorageName);
    }
  };

  return (
    <Button onClick={handleClick}>
      {isBookmarked ? (
        <StarActive
          className="star-visible"
          width="24"
          height="24"
          aria-hidden="true"
        />
      ) : (
        <Star className="" width="24" height="24" aria-hidden="true" />
      )}

      <span className="sr-only">{title}</span>
      <span>Merken</span>
    </Button>
  );
};

export default BookmarkButton;
